var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9001 14.0924V25.4C25.9001 25.6761 25.6762 25.9 25.4001 25.9H6.6001C6.32396 25.9 6.1001 25.6761 6.1001 25.4V14.0924C6.1001 13.9372 6.1722 13.7907 6.29524 13.6961L15.6952 6.46533C15.875 6.32708 16.1252 6.32708 16.305 6.46533L25.705 13.6961C25.828 13.7907 25.9001 13.9372 25.9001 14.0924Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8936 18.6411C13.8936 18.0888 14.3413 17.6411 14.8936 17.6411H17.1064C17.6587 17.6411 18.1064 18.0888 18.1064 18.6411V25.8411H13.8936V18.6411Z",
    stroke: "white",
    strokeWidth: 1.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d9d1ad6d0c7df8001eb2dd7c99566b7a.svg";
export { ForwardRef as ReactComponent };